import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { addEditGiConfiguration } from "../../../../../shared/api/postCall/addEditGiConfiguration";
import { GroupInboxRoute } from "../../../../../shared/api/services/groupInbox/groupInboxConfigTypes";
import {
  ERROR_UPDATING_GI_CONFIGURATION_STATUS,
  GI_CONFIGURATION_STATUS_UPDATED_SUCCESSFULLY,
} from "../../../../../shared/constants/stringLiterals";
import { AddEditGiConfigurationPayload } from "../../../../data-model/addEditGiConfigrationPayload";

const ACTIVE_STATUS = "active";
const INACTIVE_STATUS = "inactive";

/**
 * Persists a ViewCard active/inactive toggle through the GI push-config API.
 *
 * Omits `config` so the backend updates metadata only (status), matching
 * {@link handleGiConfigUpdate} for edit-without-config-change.
 *
 * @param isActive - Whether the toggle was switched on
 * @param version - View-tab document id sent as `meta.version`
 * @param orgId - Organization that owns the configuration
 * @param viewTab - Display name used in the success/error toast
 * @param route - Configuration source ('rpa' or 'api') the document belongs to
 * @returns True when the API reports success; false when it fails
 */
export const handleGiConfigToggleStatus = async (
  isActive: boolean,
  version: string,
  orgId: string,
  viewTab: string,
  route: GroupInboxRoute,
): Promise<boolean> => {
  const payload: AddEditGiConfigurationPayload = {
    org_id: orgId,
    meta: {
      version,
      view_tab: viewTab,
      status: isActive ? ACTIVE_STATUS : INACTIVE_STATUS,
    },
    route: route,
  };

  let succeeded = false;
  await addEditGiConfiguration(payload, {
    onSuccess: () => {
      succeeded = true;
      toast.success(
        `${GI_CONFIGURATION_STATUS_UPDATED_SUCCESSFULLY} for ${viewTab}`,
      );
    },
    onError: () => {
      toast.error(`${ERROR_UPDATING_GI_CONFIGURATION_STATUS} for ${viewTab}`);
    },
  });
  return succeeded;
};
